module.exports = __webpack_public_path__ + "img/开通无感.d4f2e2a9.png";